 <!-- logout popup -->
 <div  class="modal fade show px-2" id="exampleModalCenter" tabindex="-1" aria-modal="true"
 aria-labelledby="exampleModalCenterTitle" style="display: block; background: #00000030" role="dialog">
 <div class="modal-dialog modal-dialog-centered">
   <div class="modal-content">
     <div class="modal-header">
       <h5 class="modal-title" id="exampleModalCenterTitle">Confirm Logout</h5>
       <button (click)="configService.isShowLogOutConfirm = false" type="button" class="close" data-dismiss="modal"
         aria-label="Close">
         <span aria-hidden="true">×</span>
       </button>
     </div>
     <div class="modal-body">
       <p>Do you realy want to logout?</p>
     </div>
     <div class="modal-footer">
       <div class="row w-100">
         <div class="col-6 p-0 pr-1">
           <button (click)="configService.isShowLogOutConfirm = false" class="btn btn-secondary button-base w-100"
             style="background: #abacad">
             Cancel
           </button>
         </div>
         <div class="col-6 p-0 pr-1">
           <button (click)="confirmLogOut()" class="btn button-base btn-success w-100">
             Confirm
           </button>
         </div>
       </div>
     </div>
   </div>
 </div>
</div>
